import { parseDurationText, toIsoDuration } from '@/tracker/entities/worklog';

export const validateEstimation = (text: string): string | null =>
  !text.trim() || parseDurationText(text) !== null ? null : 'Неверный формат: 2ч 30м';

/** Текст поля → ISO-длительность; пустое поле — оценку очищаем */
export const toEstimation = (text: string): string | null => {
  const minutes = text.trim() ? parseDurationText(text) : null;

  return minutes === null ? null : toIsoDuration(minutes);
};
